import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { MyCompanyAuthenticationData } from '../../../types/company-data';

export abstract class CompanyAuthenticationTabBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getMyCompanyAuthenticationData(companyId: string): Promise<MyCompanyAuthenticationData>;
}
